import React from "react";
import { t } from "ttag";

import { Image } from "../../../components/Image";
import { IConcreteBundle, IProduct } from "../../../models/catalogue";
import { format } from "../../../utils/format";

type IProps = Readonly<{
    bundle: IConcreteBundle;
    imagePath: string;
    imageAlt: string;
    buyIsDisabled: boolean;
    onAddToBasket: (product: IProduct) => void;
}>;

const buildPrice = (
    priceExcTax: string,
    priceRetail: string,
): React.ReactNode => {
    if (!priceRetail || priceRetail === priceExcTax) {
        return (
            <div className="upsell-modal-slide__price">
                {format.money(priceExcTax)}
            </div>
        );
    }
    return (
        <div className="upsell-modal-slide__price">
            <span className="ada-screenreader-only">{t`Original price:`}</span>
            <span className="upsell-modal-slide__price--strike">
                {format.money(priceRetail)}
            </span>
            <span className="ada-screenreader-only">{t`Current price:`}</span>
            <span className="upsell-modal-slide__price--highlight">
                {format.money(priceExcTax)}
            </span>
        </div>
    );
};

export const UpsellModalSlide = (props: IProps): React.ReactNode => {
    const product = props.bundle.suggested_products[0];

    const onAddToBasket = async (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        props.onAddToBasket(product);
    };

    const productTitle = product.parent ? product.parent.title : product.title;

    let addToBasketButtonText: string = t`Add to Cart`;
    if (product.attributes?.preorder?.value) {
        addToBasketButtonText = t`Pre-order`;
    }

    return (
        <div
            className="upsell-modal-slide"
            role="group"
            aria-label={props.imageAlt}
        >
            <div className="upsell-modal-slide__cta-container">
                {product.price.cosmetic_excl_tax && (
                    <div className="upsell-modal-slide__title">
                        {buildPrice(
                            product.price.cosmetic_excl_tax,
                            product.price.retail || "",
                        )}
                        <div className="upsell-modal-slide__product-title">
                            {productTitle}
                        </div>
                    </div>
                )}
                <Image
                    lazy={false}
                    className="upsell-modal-slide__image upsell-modal-slide__image--bundle"
                    src={props.imagePath}
                    alt={props.imageAlt}
                />
                <button
                    className="button upsell-modal-slide__cta upsell-modal-slide__cta--bundle al-upsell-modal__button--add-to-cart"
                    disabled={props.buyIsDisabled}
                    onClick={onAddToBasket}
                >
                    {addToBasketButtonText}
                </button>
            </div>
        </div>
    );
};
